import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as moment from 'moment-jalaali';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-school-request-allocation',

  templateUrl: './school-request-allocation.component.html',

  styleUrls: ['./school-request-allocation.component.css']

})

export class SchoolRequestAllocationComponent implements OnInit {

  lstUser: any = [];

  lst_Allocation: any = [];

  lst_Search: any = [];

  list_Checks: any = [];

  list_Checks2: any = [];

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iLog_SystemUser: new FormControl('', Validators.required),

    strComment: new FormControl('', Validators.required),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getUser();

  }

  async getUser() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`School_SystemUser_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lstUser = res;

  }

  submitValue(event) {

    this.lst_Allocation = [];

    this.list_Checks = [];

    this.list_Checks2 = [];

    if (event?.iSystemUser) {

      this.mdl_Search.patchValue({

        iLog_SystemUser: event.iSystemUser,

        strComment: event.strCombinate

      })

    }

    else {

      this.mdl_Search.patchValue({

        iLog_SystemUser: '',

        strComment: ''

      })


    }


  }


  async getRequest() {

    if (this.mdl_Search.invalid) return this._tooltip.showError('کاربری انتخاب نشده');

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Request_MessageGhathers_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Allocation = res;

    this.lst_Search = res;

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

  isSelected(item: any): boolean {

    return this.list_Checks.indexOf(item) !== -1 || item.bSelect;

  }

  isSelected2(item: any): boolean {

    return this.list_Checks2.indexOf(item) !== -1 || item.b4Annonce;

  }

  async setCheckBox(value: boolean, item: any) {

    if (value === true) {

      let model = this.mdl_Search.value;

      model.tiMadonik_RequestType = item.tiMadonik_RequestType;

      model.b4Annonce = item.b4Annonce;

      model.bDelete = false;

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_Request_MessageGhathers_AddRemove`, this._otherService.stringNumberToNumber(model))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: 'x110' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.list_Checks.push(item.tiMadonik_RequestType);

    }

    else {

      let model = this.mdl_Search.value;

      model.tiMadonik_RequestType = item.tiMadonik_RequestType;

      model.b4Annonce = item.b4Annonce;

      model.bDelete = true;

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_Request_MessageGhathers_AddRemove`, this._otherService.stringNumberToNumber(model))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: 'x110' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.list_Checks.find((value: any) => {

        if (value === item.tiMadonik_RequestType) {

          const index = this.list_Checks.indexOf(item.tiMadonik_RequestType);

          if (index !== -1) this.list_Checks.splice(index, 1);

        }

      })

    }

  }

  async setCheckBox2(value: boolean, item: any) {

    if (value === true) {

      let model = this.mdl_Search.value;

      model.tiMadonik_RequestType = item.tiMadonik_RequestType;

      model.b4Annonce = true;

      model.bDelete = item.bDelete;

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_Request_MessageGhathers_AddRemove`, this._otherService.stringNumberToNumber(model))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: 'x110' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.list_Checks.push(item.tiMadonik_RequestType);

    }

    else {

      let model = this.mdl_Search.value;

      model.tiMadonik_RequestType = item.tiMadonik_RequestType;

      model.b4Annonce = false;

      model.bDelete = item.bDelete;

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`Madonik_Request_MessageGhathers_AddRemove`, this._otherService.stringNumberToNumber(model))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: 'x110' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.list_Checks.find((value: any) => {

        if (value === item.tiMadonik_RequestType) {

          const index = this.list_Checks.indexOf(item.tiMadonik_RequestType);

          if (index !== -1) this.list_Checks.splice(index, 1);

        }

      })

    }

  }

  async AddRemoveAll(bDelete: boolean = false) {

    if (this.mdl_Search.invalid) return this._tooltip.showError('کاربری انتخاب نشده');

    let model = this.mdl_Search.value;

    model.bDelete = bDelete;

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Madonik_Request_MessageGhathers_AddRemoveAll`, this._otherService.stringNumberToNumber(model))).data.toString());

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x110' } });

      return;

    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.getRequest();


  }

  filter_list(val: any) {

    this.lst_Allocation = this.lst_Search.filter((el: any) => {

      return el.strComment.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Allocation = this.lst_Search;

    }

  }



}
